export default __webpack_public_path__ + "static/l1-feature-oval-dedfd5e6a061e2069cb1511f22b7ec55.png";